import { EventsAwardsFooterFactory } from "@events-awards/utils/helpers";
import { AwardType } from "@events-awards/utils/types";

type EventsAwardsLogoMenuProps = {
  awardType: AwardType;
};

const EventsAwardsFooter = ({
  awardType,
}: EventsAwardsLogoMenuProps): React.ReactElement => {
  const Layout = EventsAwardsFooterFactory(awardType);

  return <>{Layout ? <Layout /> : null}</>;
};

export default EventsAwardsFooter;
